export default __webpack_public_path__ + "static/media/CSSW-15167-SOTD-Certificate.802496f1.webp";